import { from } from 'rxjs'

import { CustomerAPI } from 'api'
import { rxCheckStatus, rxPluckData, rxRetryWithBackoff } from 'utils/api'

export const fetchGeolocation = () =>
  from(CustomerAPI.get('/location')).pipe(
    rxCheckStatus(),
    rxRetryWithBackoff(),
    rxPluckData()
  )
